import { FaGithub, FaHome, FaInstagram, FaMailBulk, FaPhone, FaWhatsapp } from "react-icons/fa";
import "./FooterStyle.css";

import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <FaHome size={20} style={{color: "#fff", marginRight: "2rem"}}/>
                    <div>
                        <p>Q/Industriel. Lubumbashi.</p>
                    </div>
                </div>
                <div className="phone">
                    <h4><FaPhone size={20} style={{color: "#fff", marginRight: "2rem"}}/>
                        +243 89 78 41 194 || +243 82 21 59 649</h4>
                </div>
                <div className="email">
                    <h4><FaMailBulk size={20} style={{color: "#fff", marginRight: "2rem"}}/>
                        bethelkens9@gmail.com</h4>
                </div>
            </div>

            <div className="right">
                <h4>About me</h4>
                <p>Ingenieur des systemes d'informations "ISI", Software Engineer.</p>
                <div className="social">
                    <FaWhatsapp size={30} style={{color: "#fff", marginRight: "1rem"}}/>
                    <FaInstagram size={30} style={{color: "#fff", marginRight: "1rem"}}/>
                    <FaGithub size={30} style={{color: "#fff", marginRight: "1rem"}}/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer